import BaseButton from "./BaseButton";
import { Sounds } from "../../types/Enum";
import { ButtonBounds } from "../../types/Interface";


export default class OptionsButton extends BaseButton {

  constructor(bounds: ButtonBounds) {
    super("options", Sounds.click1);
    Object.assign(this, bounds)
  }
  handlePress() {
    this.EventBus.emit(this.EnumEventBus.setOptionsPopupVis, true)
  }
}